const keyDataOne = [
  // 一、出入库任务

  // 仓库信息
  {chaName: '$仓库名称$', engName: 'warehouseName'},
  {chaName: '$仓库地址$', engName: 'warehouseAddress'},
  {chaName: '$仓库联系人$', engName: 'warehouseHeadPeople'},
  {chaName: '$仓库联系电话$', engName: 'warehousePhone'},
  // 收货信息
  {chaName: '$配送仓点$', engName: 'ydppName'},
  {chaName: '$配送仓点地址$', engName: 'ydppAddress'},
  {chaName: '$仓点联系人$', engName: 'ydppLinkman'},
  {chaName: '$仓点联系电话$', engName: 'ydppTel'},
  // 送货信息
  {chaName: '$供应商$', engName: 'supplierName'},
  {chaName: '$供应商店铺名称$', engName: 'supplierShopName'},
  {chaName: '$供应商联系电话$', engName: 'supplierTelephone'},
  {chaName: '$出入库性质$', engName: 'taskTypeName'},
  {chaName: '$任务编号$', engName: 'taskCode'},
  {chaName: '$创建人$', engName: 'taskCreateIdName'},
  {chaName: '$创建时间$', engName: 'taskCreateTime'},
  {chaName: '$完成时间$', engName: 'taskFinishTime'},
  {chaName: '$任务备注$', engName: 'taskNote'},
  {chaName: '$供应商地址$', engName: 'supplierAddress'},
  {chaName: '$供应商联系人$', engName: 'supplierContact'},
  // 商品信息 (出库单，入库单，上架单)
  {chaName: '$商品名称$', engName: 'name'},
  {chaName: '$商品编码$', engName: 'goodsCode'},
  {chaName: '$规格$', engName: 'standard'},
  {chaName: '$箱规$', engName: 'box'},
  {chaName: '$商品属性$', engName: 'typeName'},
  {chaName: '$完成总数量(箱+件)$', engName: 'goodsTotalNumTwo'},
  {chaName: '$完成总数量(件)$', engName: 'goodsTotalNumOne'},
  {chaName: '$完成数量(正常品)$', engName: 'actualNum'},
  {chaName: '$完成数量(破损品)$', engName: 'actualWornNum'},
  {chaName: '$商品条码(69码)$', engName: 'barCode'},

  // 统计
  {chaName: '$SKU种数$', engName: 'goodsSku'},
  {chaName: '$共计件数$', engName: 'goodsTotalPiece'},
  // 系统信息
  {chaName: '$系统日期$', engName: 'localDate'},
  {chaName: '$系统时分$', engName: 'localTimeOnlyHm'}

]
const keyDataTwo = [
  // 二、上架单

  // 1. 基础信息
  {chaName: '$原库区$', engName: 'areaName'},
  {chaName: '$原货位$', engName: 'locationCode'},
  {chaName: '$供应商$', engName: 'supplierName'},
  {chaName: '$来源$', engName: 'sourceTypeName'},
  {chaName: '$入库任务编号$', engName: 'taskCode'},
  {chaName: '$创建人$', engName: 'shelvesCreateIdName'},
  {chaName: '$创建时间$', engName: 'shelvesCreateTime'},
  {chaName: '$单据编号$', engName: 'shelvesCode'},

  // 2. 上架商品（从详情页带入）
  {chaName: '$商品名称$', engName: 'goodName'},
  {chaName: '$商品条码$', engName: 'barCode'},
  {chaName: '$生产日期$', engName: 'ysdgProductionTime'},
  {chaName: '$商品总数量(正)(件)$', engName: 'allNum'},
  {chaName: '$商品总数量(正)(箱+件)$', engName: 'allNumBox'},
  {chaName: '$未上架(正)(件)$', engName: 'ysdgInventory'},
  {chaName: '$未上架(正)(箱+件)$', engName: 'ysdgInventoryBox'},
  {chaName: '$已上架(正)(件)$', engName: 'ysdgShelves'},
  {chaName: '$已上架(正)(箱+件)$', engName: 'ysdgShelvesBox'},
  {chaName: '$已取消(正)(件)$', engName: 'ysdgCancel'},
  {chaName: '$已取消(正)(箱+件)$', engName: 'ysdgCancelBox'},
  {chaName: '$中途出库(正)(件)$', engName: 'ysdgOutbound'},
  {chaName: '$中途出库(正)(箱+件)$', engName: 'ysdgOutboundBox'},
  {chaName: '$商品总数量(破)(件)$', engName: 'brokenAllNum'},
  {chaName: '$商品总数量(破)(箱+件)$', engName: 'brokenAllNumBox'},
  {chaName: '$未上架(破)(件)$', engName: 'ysdgBrokenInventory'},
  {chaName: '$未上架(破)(箱+件)$', engName: 'ysdgBrokenInventoryBox'},
  {chaName: '$已上架(破)(件)$', engName: 'ysdgBrokenShelves'},
  {chaName: '$已上架(破)(箱+件)$', engName: 'ysdgBrokenShelvesBox'},
  {chaName: '$已取消(破)(件)$', engName: 'ysdgBrokenCancel'},
  {chaName: '$已取消(破)(箱+件)$', engName: 'ysdgBrokenCancelBox'},
  {chaName: '$中途出库(破)(件)$', engName: 'ysdgBrokenOutbound'},
  {chaName: '$中途出库(破)(箱+件)$', engName: 'ysdgBrokenOutboundBox'},

  // 3. 统计
  {chaName: '$SKU种数$', engName: 'goodsSku'},
  {chaName: '$共计件数$', engName: 'goodsTotalPiece'},

  // 4.系统信息
  {chaName: '$系统日期$', engName: 'localDate'},
  {chaName: '$系统时分$', engName: 'localTimeOnlyHm'}
]

const keyDataThree = [
  // 三、拣货单

  // 1. 基础信息
  {chaName: '$供应商$', engName: 'supplierName'},
  {chaName: '$单据编号$', engName: 'taskCode'},
  {chaName: '$任务类型$', engName: 'taskTypeName'},
  {chaName: '$配送仓点$', engName: 'ydppName'},
  {chaName: '$创建人$', engName: 'taskCreateIdName'},
  {chaName: '$创建时间$', engName: 'taskCreateTime'},

  // 2. 拣货商品（从详情页带入）
  {chaName: '$商品名称$', engName: 'name'},
  {chaName: '$库位$', engName: 'goodsShelvesWarehouseAddressNames'},
  {chaName: '$商品条码$', engName: 'barCode'},
  {chaName: '$生产日期$', engName: 'productionTime'},
  {chaName: '$计划数量(正)(件)$', engName: 'normal'},
  {chaName: '$计划数量(正)(箱+件)$', engName: 'normalBox'},
  {chaName: '$未拣(正)(件)$', engName: 'unNormal'},
  {chaName: '$未拣(正)(箱+件)$', engName: 'unNormalBox'},
  {chaName: '$已拣(正)(件)$', engName: 'normaled'},
  {chaName: '$已拣(正)(箱+件)$', engName: 'normaledBox'},
  {chaName: '$已取消(正)(件)$', engName: 'normalCancel'},
  {chaName: '$已取消(正)(箱+件)$', engName: 'normalCancelBox'},
  {chaName: '$计划数量(破)(件)$', engName: 'broken'},
  {chaName: '$计划数量(破)(箱+件)$', engName: 'brokenBox'},
  {chaName: '$未拣(破)(件)$', engName: 'unBroken'},
  {chaName: '$未拣(破)(箱+件)$', engName: 'unBrokenBox'},
  {chaName: '$已拣(破)(件)$', engName: 'brokened'},
  {chaName: '$已拣(破)(箱+件)$', engName: 'brokenedBox'},
  {chaName: '$已取消(破)(件)$', engName: 'brokenCancel'},
  {chaName: '$已取消(破)(箱+件)$', engName: 'brokenCancelBox'},

  // 3. 统计
  {chaName: '$SKU种数$', engName: 'goodsSku'},
  {chaName: '$共计件数$', engName: 'goodsTotalPiece'},

  // 4.系统信息
  {chaName: '$系统日期$', engName: 'localDate'},
  {chaName: '$系统时分$', engName: 'localTimeOnlyHm'}
]
const regKeyDataOne = [
  // 一、出入库任务

  // 仓库信息
  {chaName: /\$仓库名称\$/, engName: 'warehouseName'},
  {chaName: /\$仓库地址\$/, engName: 'warehouseAddress'},
  {chaName: /\$仓库联系人\$/, engName: 'warehouseHeadPeople'},
  {chaName: /\$仓库联系电话\$/, engName: 'warehousePhone'},
  // 收货信息
  {chaName: /\$配送仓点\$/, engName: 'ydppName'},
  {chaName: /\$库位\$/, engName: 'goodsShelvesWarehouseAddressNames'},
  {chaName: /\$配送仓点地址\$/, engName: 'ydppAddress'},
  {chaName: /\$仓点联系人\$/, engName: 'ydppLinkman'},
  {chaName: /\$仓点联系电话\$/, engName: 'ydppTel'},
  // 送货信息
  {chaName: /\$供应商\$/, engName: 'supplierName'},
  {chaName: /\$供应商店铺名称\$/, engName: 'supplierShopName'},
  {chaName: /\$供应商联系电话\$/, engName: 'supplierTelephone'},
  {chaName: /\$出入库性质\$/, engName: 'taskTypeName'},
  {chaName: /\$任务编号\$/, engName: 'taskCode'},
  {chaName: /\$创建人\$/, engName: 'taskCreateIdName'},
  {chaName: /\$创建时间\$/, engName: 'taskCreateTime'},
  {chaName: /\$完成时间\$/, engName: 'taskFinishTime'},
  {chaName: /\$任务备注\$/, engName: 'taskNote'},
  {chaName: /\$供应商地址\$/, engName: 'supplierAddress'},
  {chaName: /\$供应商联系人\$/, engName: 'supplierContact'},
  // 商品信息
  {chaName: /\$商品名称\$/, engName: 'name'},
  {chaName: /\$商品编码\$/, engName: 'goodsCode'},
  {chaName: /\$规格\$/, engName: 'standard'},
  {chaName: /\$箱规\$/, engName: 'box'},
  {chaName: /\$商品属性\$/, engName: 'typeName'},
  {chaName: /\$完成总数量\(箱\+件\)\$/, engName: 'goodsTotalNumTwo'},
  {chaName: /\$完成总数量\(件\)\$/, engName: 'goodsTotalNumOne'},
  {chaName: /\$完成数量\(正常品\)\$/, engName: 'actualNum'},
  {chaName: /\$完成数量\(破损品\)\$/, engName: 'actualWornNum'},
  {chaName: /\$商品条码\(69码\)\$/, engName: 'barCode'},
  // 统计
  {chaName: /\$SKU种数\$/, engName: 'goodsSku'},
  {chaName: /\$共计件数\$/, engName: 'goodsTotalPiece'},
  // 系统信息
  {chaName: /\$系统日期\$/, engName: 'localDate'},
  {chaName: /\$系统时分\$/, engName: 'localTimeOnlyHm'}
]

const regKeyDataTwo = [
  // 二、上架单

  // 1. 基础信息
  {chaName: /\$原库区\$/, engName: 'areaName'},
  {chaName: /\$原货位\$/, engName: 'locationCode'},
  {chaName: /\$供应商\$/, engName: 'supplierName'},
  {chaName: /\$来源\$/, engName: 'sourceTypeName'},
  {chaName: /\$入库任务编号\$/, engName: 'taskCode'},
  {chaName: /\$创建人\$/, engName: 'shelvesCreateIdName'},
  {chaName: /\$创建时间\$/, engName: 'shelvesCreateTime'},
  {chaName: /\$单据编号\$/, engName: 'shelvesCode'},

  // 2. 上架商品（从详情页带入）
  {chaName: /\$商品名称\$/, engName: 'goodName'},
  {chaName: /\$商品条码\$/, engName: 'barCode'},
  {chaName: /\$库位\$/, engName: 'goodsShelvesWarehouseAddressNames'},
  {chaName: /\$生产日期\$/, engName: 'ysdgProductionTime'},
  {chaName: /\$商品总数量\(正\)\(件\)\$/, engName: 'allNum'},
  {chaName: /\$商品总数量\(正\)\(箱\+件\)\$/, engName: 'allNumBox'},
  {chaName: /\$未上架\(正\)\(件\)\$/, engName: 'ysdgInventory'},
  {chaName: /\$未上架\(正\)\(箱\+件\)\$/, engName: 'ysdgInventoryBox'},
  {chaName: /\$已上架\(正\)\(件\)\$/, engName: 'ysdgShelves'},
  {chaName: /\$已上架\(正\)\(箱\+件\)\$/, engName: 'ysdgShelvesBox'},
  {chaName: /\$已取消\(正\)\(件\)\$/, engName: 'ysdgCancel'},
  {chaName: /\$已取消\(正\)\(箱\+件\)\$/, engName: 'ysdgCancelBox'},
  {chaName: /\$中途出库\(正\)\(件\)\$/, engName: 'ysdgOutbound'},
  {chaName: /\$中途出库\(正\)\(箱\+件\)\$/, engName: 'ysdgOutboundBox'},
  {chaName: /\$商品总数量\(破\)\(件\)\$/, engName: 'brokenAllNum'},
  {chaName: /\$商品总数量\(破\)\(箱\+件\)\$/, engName: 'brokenAllNumBox'},
  {chaName: /\$未上架\(破\)\(件\)\$/, engName: 'ysdgBrokenInventory'},
  {chaName: /\$未上架\(破\)\(箱\+件\)\$/, engName: 'ysdgBrokenInventoryBox'},
  {chaName: /\$已上架\(破\)\(件\)\$/, engName: 'ysdgBrokenShelves'},
  {chaName: /\$已上架\(破\)\(箱\+件\)\$/, engName: 'ysdgBrokenShelvesBox'},
  {chaName: /\$已取消\(破\)\(件\)\$/, engName: 'ysdgBrokenCancel'},
  {chaName: /\$已取消\(破\)\(箱\+件\)\$/, engName: 'ysdgBrokenCancelBox'},
  {chaName: /\$中途出库\(破\)\(件\)\$/, engName: 'ysdgBrokenOutbound'},
  {chaName: /\$中途出库\(破\)\(箱\+件\)\$/, engName: 'ysdgBrokenOutboundBox'},

  // 3. 统计
  {chaName: /\$SKU种数\$/, engName: 'goodsSku'},
  {chaName: /\$共计件数\$/, engName: 'goodsTotalPiece'},

  // 4.系统信息
  {chaName: /\$系统日期\$/, engName: 'localDate'},
  {chaName: /\$系统时分\$/, engName: 'localTimeOnlyHm'}
]
const regKeyDataThree = [
  // 三、拣货单

  // 1. 基础信息
  {chaName: /\$供应商\$/, engName: 'supplierName'},
  {chaName: /\$单据编号\$/, engName: 'taskCode'},
  {chaName: /\$任务类型\$/, engName: 'taskTypeName'},
  {chaName: /\$配送仓点\$/, engName: 'ydppName'},
  {chaName: /\$创建人\$/, engName: 'taskCreateIdName'},
  {chaName: /\$创建时间\$/, engName: 'taskCreateTime'},

  // 2. 拣货商品（从详情页带入）
  {chaName: /\$商品名称\$/, engName: 'name'},
  {chaName: /\$库位\$/, engName: 'goodsShelvesWarehouseAddressNames'},
  {chaName: /\$商品条码\$/, engName: 'barCode'},
  {chaName: /\$生产日期\$/, engName: 'productionTime'},
  {chaName: /\$计划数量\(正\)\(件\)\$/, engName: 'normal'},
  {chaName: /\$计划数量\(正\)\(箱\+件\)\$/, engName: 'normalBox'},
  {chaName: /\$未拣\(正\)\(件\)\$/, engName: 'unNormal'},
  {chaName: /\$未拣\(正\)\(箱\+件\)\$/, engName: 'unNormalBox'},
  {chaName: /\$已拣\(正\)\(件\)\$/, engName: 'normaled'},
  {chaName: /\$已拣\(正\)\(箱\+件\)\$/, engName: 'normaledBox'},
  {chaName: /\$已取消\(正\)\(件\)\$/, engName: 'normalCancel'},
  {chaName: /\$已取消\(正\)\(箱\+件\)\$/, engName: 'normalCancelBox'},
  {chaName: /\$计划数量\(破\)\(件\)\$/, engName: 'broken'},
  {chaName: /\$计划数量\(破\)\(箱\+件\)\$/, engName: 'brokenBox'},
  {chaName: /\$未拣\(破\)\(件\)\$/, engName: 'unBroken'},
  {chaName: /\$未拣\(破\)\(箱\+件\)\$/, engName: 'unBrokenBox'},
  {chaName: /\$已拣\(破\)\(件\)\$/, engName: 'brokened'},
  {chaName: /\$已拣\(破\)\(箱\+件\)\$/, engName: 'brokenedBox'},
  {chaName: /\$已取消\(破\)\(件\)\$/, engName: 'brokenCancel'},
  {chaName: /\$已取消\(破\)\(箱\+件\)\$/, engName: 'brokenCancelBox'},

  // 3. 统计
  {chaName: /\$SKU种数\$/, engName: 'goodsSku'},
  {chaName: /\$共计件数\$/, engName: 'goodsTotalPiece'},

  // 4.系统信息
  {chaName: /\$系统日期\$/, engName: 'localDate'},
  {chaName: /\$系统时分\$/, engName: 'localTimeOnlyHm'}
]
// 传中找英
export function getEngKey (str, mode) {
  if (!str) {
    return ''
  }
  let keyData = []
  // eslint-disable-next-line eqeqeq
  if (mode == 1) {
    keyData = keyDataOne
  // eslint-disable-next-line eqeqeq
  } else if (mode == 2) {
    keyData = keyDataThree
  // eslint-disable-next-line eqeqeq
  } else if (mode == 3) {
    keyData = keyDataTwo
  }
  let newStr = ''
  keyData.forEach(x => {
    if (x.chaName === str) {
      newStr = x.engName
    }
  })
  return newStr
}

// 传英找中
export function getChaKey (str, mode) {
  if (!str) {
    return ''
  }
  let keyData = []
  // console.log(mode)
  // eslint-disable-next-line eqeqeq
  if (mode == 1) {
    keyData = regKeyDataOne
  // eslint-disable-next-line eqeqeq
  } else if (mode == 2) {
    keyData = regKeyDataThree
  // eslint-disable-next-line eqeqeq
  } else if (mode == 3) {
    keyData = regKeyDataTwo
  }
  let newStr = ''
  keyData.forEach(x => {
    if (x.engName === str) {
      newStr = x.chaName
    }
  })
  return newStr
}



// WEBPACK FOOTER //
// ./src/utils/getPrintTempKey.js